import { Vue, Component, Prop, Emit } from 'vue-property-decorator'
import StatisticalInfoPaginator from '@/modules/statistical-analysis-module/shared/components/statistical-analysis-info-paginator/statistical-analysis-info-paginator.vue'
import StatisticalAnalysisViewDetail from '@/modules/statistical-analysis-module/shared/components/statistical-analysis-view-detail/statistical-analysis-view-detail.vue'
import { StatisticalAnalysisViewDetailParams } from '@/modules/statistical-analysis-module/shared/models/shared.model'
import { StatisticalInfoPaginatorTrackingItems } from '@/modules/statistical-analysis-module/shared/components/statistical-analysis-info-paginator/statistical-analysis-info-paginator.model'
import { StatisticalAnalysisGeneralDossierExternalInfo, StatisticsAnalysisGeneralStatisticsTrackingItems } from '@/modules/statistical-analysis-module/views/general-statistics-dossier/general-statistics-dossier.model'
import { Nullable } from '@/shared/types/app.types'
@Component({
    components: {
        StatisticalInfoPaginator,
        StatisticalAnalysisViewDetail
    }
})
export default class StatisticalAnalysisGeneralStatisticsDetail extends Vue {
    @Prop() readonly externalInfo!: StatisticalAnalysisGeneralDossierExternalInfo
    @Prop() readonly viewDetailParams!: StatisticalAnalysisViewDetailParams
    @Emit()
    backView(): boolean {
        return true
    }

    get trackingItems(): StatisticalInfoPaginatorTrackingItems[] {
        const trackingItemsFiltered = this.externalInfo.trackingItems.filter((item: StatisticsAnalysisGeneralStatisticsTrackingItems) => item.active && item.value > 0)
        return trackingItemsFiltered.map((item:StatisticsAnalysisGeneralStatisticsTrackingItems) => {
            return {
                key: item.key,
                label: item.label,
                value: item.value
            }
        })
    }

    get trackingSelected(): Nullable<StatisticalInfoPaginatorTrackingItems> {
        return this.externalInfo.trackingDetailSelected
    }

    onBackView(): void {
        this.backView()
    }

    onChangeTrackItem(value: StatisticalInfoPaginatorTrackingItems): void {
        this.externalInfo.trackingDetailSelected = value
    }
}
